import { useQuery } from "react-query";
import { getAllInspections } from "services/inspection.service";

export default function useInspections(params?: { page?: number; limit?: number }) {
  return useQuery(["inspections", params], () => getAllInspections(params), {
    keepPreviousData: true,
  });
}
